import { useState } from "react";
import { Link, useSearchParams } from "react-router";
import { MailCheck } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { AuthLayout } from "@/layouts/AuthLayout";
import { authClient } from "@/lib/auth-client";
import { t } from "@shared/i18n";

export function CheckEmail() {
  const [params] = useSearchParams();
  const email = params.get("email") ?? "";
  const [loading, setLoading] = useState(false);
  return (
    <AuthLayout title={t("Vérifiez votre boîte mail.")} footer={<Link to="/login" className="text-primary hover:underline">{t("Retour à la connexion")}</Link>}>
      <div className="glass-card p-5 text-sm leading-relaxed">
        <MailCheck className="mb-3 size-6 text-primary" />
        {t("Nous avons envoyé un lien de confirmation à")} <strong>{email || t("votre adresse")}</strong>{t(". Cliquez dessus pour activer votre compte et commencer la configuration.")}
      </div>
      {email && (
        <Button
          variant="ghost"
          className="mt-4 w-full"
          loading={loading}
          onClick={async () => {
            setLoading(true);
            const { error } = await authClient.sendVerificationEmail({ email, callbackURL: `${window.location.origin}/onboarding` });
            setLoading(false);
            if (error) toast.error(error.status === 429 ? t("Patientez quelques minutes avant un nouvel envoi.") : t("Envoi impossible."));
            else toast.success(t("E-mail renvoyé."));
          }}
        >
          {t("Renvoyer l'e-mail")}
        </Button>
      )}
    </AuthLayout>
  );
}
